import React, {
  ReactElement, ReactNode, useMemo, useState,
} from 'react';
import CallbackContext from './CallbackContext';

type Fn = () => Promise<void>;

interface CallbackContextProviderProps {
  children: ReactNode,
}

export default ({ children }: CallbackContextProviderProps): ReactElement => {
  const [callback, setCallback] = useState<Fn>();

  const contextValue = useMemo(() => ({
    callback, setCallback,
  }), [callback]);

  return (
    <CallbackContext.Provider value={contextValue}>
      {children}
    </CallbackContext.Provider>
  );
};
